import { Add, Launch } from "@mui/icons-material";
import {
  Avatar,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";

type AcceptedServicesListProps = {
  serviceSectors?: string[];
};

export const AcceptedServicesList = ({
  serviceSectors
}: AcceptedServicesListProps) => {
  if (!serviceSectors?.length)
    return <Typography my={2}>No accepted service sectors</Typography>;

  return (
    <List>
      {serviceSectors?.map((serviceSector, index) => (
        <ListItem key={index}>
          <ListItemButton
            component="a"
            href={`https://www.google.com/search?q=${encodeURIComponent(
              `${serviceSector} near me`
            )}`}
            target="_blank"
            rel="noreferrer"
          >
            <ListItemIcon>
              <Avatar sx={{ bgcolor: "primary.main" }}>
                <Add
                  style={{
                    color: "#A8DFDC"
                  }}
                  fontSize="large"
                />
              </Avatar>
            </ListItemIcon>
            <ListItemText primary={serviceSector} />
            <Launch />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};
